(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3052],{

/***/ 50422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* reexport */ Badge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/styleguide/Badge/badge.module.scss
var badge_module = __webpack_require__(3154);
var badge_module_default = /*#__PURE__*/__webpack_require__.n(badge_module);
;// CONCATENATED MODULE: ./components/styleguide/Badge/Badge.tsx


var Badge = function(param) {
    var label = param.label, _className = param.className, className = _className === void 0 ? "" : _className, _type = param.type, type = _type === void 0 ? "standard" : _type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "".concat((badge_module_default()).main, " ").concat(className),
        "data-badge-type": type,
        children: label
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Badge/index.ts



/***/ }),

/***/ 63052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ VehicleCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14416);
/* harmony import */ var _vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92928);
/* harmony import */ var _vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _components_styleguide_Badge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50422);
/* harmony import */ var _components_styleguide_LocoScore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27838);
/* harmony import */ var _components_styleguide_VehicleImage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52733);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99280);
/* harmony import */ var _lib_services_searchService__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74829);
/* harmony import */ var _lib_utilities_search__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45425);
/* harmony import */ var _lib_utilities_vehicle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(13732);
/* harmony import */ var _store_selectors_search__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29906);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16693);















var Icon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var VehicleCard = function(param) {
    var deal = param.deal, _type = param.type, type = _type === void 0 ? "list" : _type, _isPriority = param.isPriority, isPriority = _isPriority === void 0 ? false : _isPriority;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(deal.vehiclePrice.leaseType === _lib_constants__WEBPACK_IMPORTED_MODULE_8__/* .FILTER_LEASE_TYPES_PERSONAL */ .m_), includeVat = ref1[0], setIncludeVat = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), pcpDifference = ref2[0], setPcpDifference = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), showPcpDifference = ref3[0], setShowPcpDifference = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isLocoDayDeal = ref4[0];
    var grouping = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(_store_selectors_search__WEBPACK_IMPORTED_MODULE_12__/* .selectGrouping */ .$Q);
    var vehicleGalleryImages = (ref = deal.vehicle.gallery) === null || ref === void 0 ? void 0 : ref.images;
    var getDisplayPrice = function(vehiclePrice) {
        return (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_10__/* .formatPrice */ .T4)(includeVat ? (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_10__/* .addVatToPrice */ .QR)(vehiclePrice.monthlyPayment) : vehiclePrice.monthlyPayment);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        setIncludeVat(deal.vehiclePrice.leaseType === _lib_constants__WEBPACK_IMPORTED_MODULE_8__/* .FILTER_LEASE_TYPES_PERSONAL */ .m_);
    }, [
        deal
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var controller = new AbortController();
        if (deal && includeVat && type !== "recently-viewed") {
            (0,_lib_services_searchService__WEBPACK_IMPORTED_MODULE_9__/* .getPcpPricesForPersonalService */ .TC)({
                term: deal.vehiclePrice.term,
                mileage: deal.vehiclePrice.mileage,
                initialPaymentInMonths: deal.vehiclePrice.initialPaymentInMonths,
                vehicleId: deal.vehicle.id
            }).then(function(res) {
                var difference = (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_10__/* .addVatToPrice */ .QR)(res.monthlyPayment - deal.vehiclePrice.monthlyPayment);
                setPcpDifference(parseFloat(difference));
                if (parseFloat(difference) > 0) {
                    setShowPcpDifference(true);
                }
            }).catch(function() {
                setPcpDifference(0);
            });
        }
        return function() {
            controller.abort();
        };
    }, [
        includeVat,
        deal,
        type
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: (0,_lib_utilities_vehicle__WEBPACK_IMPORTED_MODULE_11__/* .generateVehicleLink */ .tG)(deal.vehiclePrice, "config"),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            onClick: function(e) {
                // if user is clicking on navigation button, don't go through to config page
                if (e.target.nodeName === "BUTTON") {
                    e.preventDefault();
                }
            },
            "data-type": type,
            className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default().container),
            title: "".concat(deal.vehicle.manufacturerName, " ").concat(deal.vehicle.modelName).concat(grouping === 1 ? " " + deal.vehicle.derivativeName : ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default().main),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["image-container"]),
                        children: [
                            vehicleGalleryImages ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_VehicleImage__WEBPACK_IMPORTED_MODULE_7__/* .VehicleImageWithGallery */ .C, {
                                images: vehicleGalleryImages || [],
                                alt: "".concat(deal.vehicle.manufacturerName, " ").concat(deal.vehicle.modelName),
                                height: 234,
                                type: "BROWSE",
                                width: 352
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_VehicleImage__WEBPACK_IMPORTED_MODULE_7__/* .VehicleImage */ .o, {
                                imagePath: "",
                                backupImagePath: deal.vehicle.images.profile,
                                alt: "".concat(deal.vehicle.manufacturerName, " ").concat(deal.vehicle.modelName),
                                height: 234,
                                type: "BROWSE",
                                width: 352,
                                priority: isPriority
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_LocoScore__WEBPACK_IMPORTED_MODULE_6__/* .LocoScore */ .o, {
                                rating: deal.vehiclePrice.rating,
                                className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default().score)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["detail-container"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    (deal.vehiclePrice.stockStatus === _lib_constants__WEBPACK_IMPORTED_MODULE_8__/* .FILTER_STOCK_STATUS_IN_STOCK */ .Wx || deal.vehicle.fuelType === 5 || isLocoDayDeal) && type !== "recently-viewed" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default().badges),
                                        children: [
                                            deal.vehiclePrice.stockStatus === _lib_constants__WEBPACK_IMPORTED_MODULE_8__/* .FILTER_STOCK_STATUS_IN_STOCK */ .Wx && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Badge__WEBPACK_IMPORTED_MODULE_5__/* .Badge */ .C, {
                                                label: "In stock",
                                                type: "stock-status"
                                            }),
                                            deal.vehicle.fuelType === 5 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Badge__WEBPACK_IMPORTED_MODULE_5__/* .Badge */ .C, {
                                                label: "Electric",
                                                type: "electric"
                                            }),
                                            isLocoDayDeal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Badge__WEBPACK_IMPORTED_MODULE_5__/* .Badge */ .C, {
                                                label: "Locoday deal",
                                                type: "loco-day"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["make-model"]),
                                        children: [
                                            deal.vehicle.manufacturerName,
                                            " ",
                                            deal.vehicle.modelName
                                        ]
                                    }),
                                    grouping === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default().derivative),
                                        children: deal.vehicle.derivativeName
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default().attributes),
                                        "data-is-desktop-only": true,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                                                        size: _types_system__WEBPACK_IMPORTED_MODULE_13__/* .Size.Small */ .$u.Small,
                                                        name: "User"
                                                    }),
                                                    " ",
                                                    deal.vehicle.seats
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                d: "M3 11L11 3H21V11M3 11V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H19C19.5304 20 20.0391 19.7893 20.4142 19.4142C20.7893 19.0391 21 18.5304 21 18V11M3 11H21",
                                                                stroke: "#07081A",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                d: "M18 14H14",
                                                                stroke: "black",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round"
                                                            })
                                                        ]
                                                    }),
                                                    deal.vehicle.doors
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                d: "M5 9V12M5 15V12M5 12H12.25M12.25 12H19V9M12.25 12V15M12.25 12V9",
                                                                stroke: "#07081A",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                                cx: "5",
                                                                cy: "5",
                                                                r: "2",
                                                                fill: "black"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                                cx: "5",
                                                                cy: "19",
                                                                r: "2",
                                                                fill: "black"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                                cx: "12",
                                                                cy: "5",
                                                                r: "2",
                                                                fill: "black"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                                cx: "12",
                                                                cy: "19",
                                                                r: "2",
                                                                fill: "black"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                                cx: "19",
                                                                cy: "5",
                                                                r: "2",
                                                                fill: "black"
                                                            })
                                                        ]
                                                    }),
                                                    deal.vehicle.transmissionTypeName
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                                                        size: _types_system__WEBPACK_IMPORTED_MODULE_13__/* .Size.Small */ .$u.Small,
                                                        name: deal.vehicle.fuelType === 1 || deal.vehicle.fuelType === 2 ? "Fuel" : deal.vehicle.fuelType === 5 ? "Zap" : "Plug"
                                                    }),
                                                    deal.vehicle.fuelType === 5 ? "Fully electric" : (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_10__/* .fuelTypeAbbreviation */ .HW)(deal.vehicle.fuelTypeName)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    grouping === 1 && type !== "vehicle-deals" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["body-type"]),
                                        "data-is-mobile-only": true,
                                        children: deal.vehicle.derivativeName
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["body-type"]),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                "data-is-desktop-only": true,
                                                children: [
                                                    "Body type ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                                ]
                                            }),
                                            deal.vehicle.bodyStyleName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["lease-profile"]),
                                        children: [
                                            (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_10__/* .getTermsAsYearsName */ .B5)(deal.vehiclePrice.term),
                                            " y",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["hidden-extensions"]),
                                                children: "ea"
                                            }),
                                            "r",
                                            deal.vehiclePrice.term !== 12 ? "s, " : ", ",
                                            deal.vehiclePrice.initialPaymentInMonths,
                                            " mo",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["hidden-extensions"]),
                                                children: "nth"
                                            }),
                                            deal.vehiclePrice.initialPaymentInMonths > 1 ? "s" : "",
                                            " upfront",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: " \xb7 "
                                            }),
                                            (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_10__/* .formatWithCommas */ .b1)(deal.vehiclePrice.mileage),
                                            " mi."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["monthly-price"]),
                                        "data-is-mobile-only": true,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: getDisplayPrice(deal.vehiclePrice)
                                            }),
                                            " monthly",
                                            " ",
                                            !includeVat && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["small-text"]),
                                                children: "(ex VAT)"
                                            })
                                        ]
                                    }),
                                    showPcpDifference && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["pcp-saving"]),
                                        "data-is-mobile-only": true,
                                        children: [
                                            "Save ",
                                            (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_10__/* .formatPrice */ .T4)(pcpDifference),
                                            " monthly"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["summary-container"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_LocoScore__WEBPACK_IMPORTED_MODULE_6__/* .LocoScore */ .o, {
                                rating: deal.vehiclePrice.rating,
                                isInline: true,
                                className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default().score)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default().action),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["monthly-price"]),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: getDisplayPrice(deal.vehiclePrice)
                                            }),
                                            " per month",
                                            " ",
                                            !includeVat && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["small-text"]),
                                                children: "(ex VAT)"
                                            })
                                        ]
                                    }),
                                    showPcpDifference && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["pcp-saving"]),
                                        children: [
                                            "Save ",
                                            (0,_lib_utilities_search__WEBPACK_IMPORTED_MODULE_10__/* .formatPrice */ .T4)(pcpDifference),
                                            "/pm vs PCP"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_vehicle_card_module_scss__WEBPACK_IMPORTED_MODULE_14___default().configure),
                                        children: "Configure"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 3154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"badge_main__h8Whe","phAnimation":"badge_phAnimation__junPt"};

/***/ }),

/***/ 92928:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"vehicle-card_container__7xtI0","main":"vehicle-card_main__IHV_M","image-container":"vehicle-card_image-container__ehvT5","score":"vehicle-card_score__1_tc_","detail-container":"vehicle-card_detail-container__WUh2i","make-model":"vehicle-card_make-model__AeRA9","lease-profile":"vehicle-card_lease-profile__BVBEy","body-type":"vehicle-card_body-type__J7Hni","monthly-price":"vehicle-card_monthly-price__ZxnIl","old-price":"vehicle-card_old-price__eZTgR","pcp-saving":"vehicle-card_pcp-saving__1kGbX","summary-container":"vehicle-card_summary-container__yluse","action":"vehicle-card_action__P8cbt","small-text":"vehicle-card_small-text__5DTnw","badges":"vehicle-card_badges__iTeu9","attributes":"vehicle-card_attributes__toIXW","derivative":"vehicle-card_derivative__TfHEA","configure":"vehicle-card_configure__bsNP2","hidden-extensions":"vehicle-card_hidden-extensions__MuUsp","price-difference":"vehicle-card_price-difference__0FG_P","text":"vehicle-card_text__RunA4","phAnimation":"vehicle-card_phAnimation__ATmV_"};

/***/ })

}]);